import { assign } from 'fsm';
import Raven from 'raven-js';
import { getCurrentUser, refreshCurrentUser } from './client';
import { CurrentUser } from './CurrentUser';
export const machine = {
  initial: 'loadingUser',
  context: {
    isLoaded: false,
    currentUser: new CurrentUser(null),
    user: {
      created_at: 0,
      email: '',
      emails: [],
      first_name: '',
      last_name: '',
      lang_enabled: false,
      locale: '',
      partner: false,
      roles: [],
      scopes: [],
      teams: [],
      user_id: 0,
      verified: false
    },
    gates: [],
    portal: {
      created_at: 0,
      enabled_gates: [],
      expired: false,
      expired_at: null,
      family_id: 0,
      friends_and_family: false,
      limits: {},
      partner: false,
      portal_id: 0,
      product_id: 0,
      product_type: '',
      timezone: {
        id: '',
        offset: 0,
        'moment-data': ''
      },
      trial: false
    }
  },
  states: {
    loadingUser: {
      invoke: {
        src: 'getCurrentUser',
        onDone: {
          target: 'idle',
          actions: ['setUser', 'setIsLoaded', 'setCurrentUser']
        },
        onError: {
          target: 'error',
          actions: ['logError']
        }
      },
      tags: ['loading']
    },
    refreshingUser: {
      invoke: {
        src: 'refreshCurrentUser',
        onDone: {
          target: 'idle',
          actions: ['setUser', 'setIsLoaded', 'setCurrentUser']
        },
        onError: {
          target: 'error',
          actions: ['logError']
        }
      },
      on: {
        REFRESH: {}
      },
      tags: ['refreshing']
    },
    idle: {
      on: {
        REFRESH: 'refreshingUser'
      }
    },
    error: {
      on: {
        RETRY: 'loadingUser'
      }
    }
  },
  actions: {
    logError: (_context, event) => {
      const {
        responseJSON
      } = event.data;
      Raven.captureException(responseJSON);
    },
    setCurrentUser: assign((_context, event) => {
      const currentUser = new CurrentUser(event.data);
      return {
        currentUser
      };
    }),
    setIsLoaded: assign(() => {
      return {
        isLoaded: true
      };
    }),
    setUser: assign((_context, event) => {
      return event.data;
    })
  },
  services: {
    getCurrentUser,
    refreshCurrentUser
  }
};